/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchDatesV2 } from './SearchDatesV2';
import {
    SearchDatesV2FromJSON,
    SearchDatesV2FromJSONTyped,
    SearchDatesV2ToJSON,
    SearchDatesV2ToJSONTyped,
} from './SearchDatesV2';
import type { SearchOccupants } from './SearchOccupants';
import {
    SearchOccupantsFromJSON,
    SearchOccupantsFromJSONTyped,
    SearchOccupantsToJSON,
    SearchOccupantsToJSONTyped,
} from './SearchOccupants';
import type { SearchLocationV2 } from './SearchLocationV2';
import {
    SearchLocationV2FromJSON,
    SearchLocationV2FromJSONTyped,
    SearchLocationV2ToJSON,
    SearchLocationV2ToJSONTyped,
} from './SearchLocationV2';

/**
 * 
 * @export
 * @interface PortfolioOptimizationRequest
 */
export interface PortfolioOptimizationRequest {
    /**
     * 
     * @type {SearchLocationV2}
     * @memberof PortfolioOptimizationRequest
     */
    searchLocation: SearchLocationV2;
    /**
     * 
     * @type {SearchDatesV2}
     * @memberof PortfolioOptimizationRequest
     */
    searchDates: SearchDatesV2;
    /**
     * 
     * @type {SearchOccupants}
     * @memberof PortfolioOptimizationRequest
     */
    searchOccupants?: SearchOccupants;
}

/**
 * Check if a given object implements the PortfolioOptimizationRequest interface.
 */
export function instanceOfPortfolioOptimizationRequest(value: object): value is PortfolioOptimizationRequest {
    if (!('searchLocation' in value) || value['searchLocation'] === undefined) return false;
    if (!('searchDates' in value) || value['searchDates'] === undefined) return false;
    return true;
}

export function PortfolioOptimizationRequestFromJSON(json: any): PortfolioOptimizationRequest {
    return PortfolioOptimizationRequestFromJSONTyped(json, false);
}

export function PortfolioOptimizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioOptimizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'searchLocation': SearchLocationV2FromJSON(json['search_location']),
        'searchDates': SearchDatesV2FromJSON(json['search_dates']),
        'searchOccupants': json['search_occupants'] == null ? undefined : SearchOccupantsFromJSON(json['search_occupants']),
    };
}

export function PortfolioOptimizationRequestToJSON(json: any): PortfolioOptimizationRequest {
    return PortfolioOptimizationRequestToJSONTyped(json, false);
}

export function PortfolioOptimizationRequestToJSONTyped(value?: PortfolioOptimizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_location': SearchLocationV2ToJSON(value['searchLocation']),
        'search_dates': SearchDatesV2ToJSON(value['searchDates']),
        'search_occupants': SearchOccupantsToJSON(value['searchOccupants']),
    };
}

